export const scoreRuleLabels = {
    chargeback_rate: "Taxa de chargeback",
    chargeback_rate_v2: "Taxa de chargeback v2",
    box_comp_chargeback_rate: "Chargeback caixa (notificação)",
    is_verified: "Conta verificada",
    has_account_manager: "Gerente de contas",
    configured_integrations: "Integrações configuradas",
    successful_withdrawals: "Saques bem-sucedidos",
    lessons_watched: "Aulas assistidas",
    device_diversity_rate: "Diversidade de dispositivos",
    email_bounces: "Bounces de e-mail",
    has_exorbitant_ebook_sales: "E-books com preço exorbitante",
    credit_card_decline_rate: "Taxa de recusa de cartão",
    credit_card_transaction_rate: "Proporção de vendas no cartão",
    weekly_withdrawals: "Saques na semana",
    unique_cards_by_visitor_id: "Cartões únicos por visitante",
    related_low_score_accounts: "Contas relacionadas com score baixo",
    bin_diversity_rate: "Diversidade de BINs",
    affiliate_bin_diversity: "Diversidade de BINs (afiliados)",
    recent_transactions_diversity: "Diversidade de transações recentes",
    first_sale_after_affiliation: "Primeira venda pós-afiliação",
    seller_has_sold_early: "Venda logo após cadastro",
    demais_regras_do_score: "Demais regras do score",
    ChargebackRateV2: "Chargeback Rate v2",
    DeviceDiversity: "Device Diversity",
    PixRefundRate: "Pix Refund Rate",
};
